import React from 'react';
import PropTypes from 'prop-types';

import VersionSelector from '../shared/VersionSelector';
import ReportsTable from './ReportsTable';

const propTypes = {
  dataset: PropTypes.object,
  datasetId: PropTypes.number,
  getReportDownloadLink: PropTypes.func.isRequired,
  handleVersionSelectChange: PropTypes.func.isRequired,
  isIndexItem: PropTypes.bool.isRequired,
  selectedVersion: PropTypes.number,
  versions: PropTypes.array,
  versionReports: PropTypes.object,
};

const defaultProps = {
  dataset: null,
  datasetId: null,
  selectedVersion: null,
  versions: null,
  versionReports: null,
};

const SingleDatasetReports = ({
  datasetId,
  getReportDownloadLink,
  handleVersionSelectChange,
  isIndexItem,
  selectedVersion,
  dataset,
  versions,
  versionReports,
}) => (
  <div>
    {isIndexItem ? <h3>{dataset.name}</h3> : null}
    <div>
      <p>
        <VersionSelector
          handleOnChange={handleVersionSelectChange}
          selectedVersion={selectedVersion}
          versions={versions}
        />
      </p>
      <div className="row">
        <div className="col-xs-12">
          <div className="reports-preview-table">
            <ReportsTable
              datasetId={datasetId}
              getReportDownloadLink={getReportDownloadLink}
              selectedVersion={selectedVersion}
              versionReports={versionReports}
            />
          </div>
        </div>
      </div>
    </div>
  </div>
);

SingleDatasetReports.propTypes = propTypes;
SingleDatasetReports.defaultProps = defaultProps;

export default SingleDatasetReports;
